/**
 * **본 값을 다국어 사본에 따라가게 한다** — 이 로직의 유일한 소유자다.
 *
 * 메뉴 단가·옵션 단가·할인 금액·할인율이 각각 `smenuInfos` · `smenuOptInfos` · `discountInfos` 라는
 * 다국어 행 배열을 갖고 있고, 타국화폐 결제를 쓰지 않는 매장에서는 그 행들이 본 값을 그대로 따라가야
 * 한다. 그 동기화가 **네 자리에 복사돼 있었고 네 개 전부 같은 버그였다**:
 *
 * ```js
 * for (var i = 0, len = this.inputForm.smenuInfos; i < len; i++)   // ← .length 가 없다
 * ```
 *
 * `len` 이 숫자가 아니라 배열이라 `i < len` 이 언제나 false 이고 **루프 본문이 한 번도 실행된 적이
 * 없다.** 본 단가를 고쳐도 언어 탭 값이 옛 가격으로 남아 외국어 고객에게 틀린 가격이 보인다.
 *
 * 복사본마다 `.length` 를 넣는 것은 덧대기다 — 같은 실수를 다시 할 자리를 네 개 그대로 남긴다.
 * 그래서 인덱스 루프 자체를 없애고 한 곳으로 뽑았다. 호출부는 「무엇을 무엇에 따라가게 할지」만 말한다.
 *
 * @param {Array}  rows  다국어 행 배열 (`smenuInfos` 등). 배열이 아니면 아무 일도 하지 않는다.
 * @param {string} field 따라갈 필드 이름 (`'price'` · `'percente'`)
 * @param {*}      value 본 값
 */
export const syncLangValue = function (rows, field, value) {
  if (!Array.isArray(rows)) return
  rows.forEach(function (row) {
    if (row) row[field] = value
  })
}
